// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import SolyticsButton from './SolyticsButton';
import SolyticsChip from './SolyticsChip';
import { ReactComponent as FilterIcon } from '../../assets/Icons/lucideIcons/funnel.svg';

const ICON_SIZE = { small: 16, medium: 18 };

/**
 * Standard "Filters" toolbar button used on every list page.
 *
 * @param {function} onClick - Opens the filter drawer
 * @param {number} [appliedCount=0] - Number of applied filters; shows a count chip when > 0
 * @param {boolean} [disabled=false]
 * @param {'small'|'medium'} [size='medium'] - Match the sibling toolbar buttons
 * @returns {React.ReactElement}
 */
const SolyticsFilterButton = ({
  onClick,
  appliedCount = 0,
  disabled = false,
  size = 'medium',
}) => (
  <SolyticsButton
    variant="outlined"
    size={size}
    onClick={onClick}
    disabled={disabled}
    title="Filters"
    startIcon={<FilterIcon width={ICON_SIZE[size]} height={ICON_SIZE[size]} />}
    {...(appliedCount > 0 && {
      endIcon: (
        <SolyticsChip
          color="primary"
          shape="square"
          label={appliedCount}
          size="small"
        />
      ),
    })}
  >
    Filters
  </SolyticsButton>
);

SolyticsFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  appliedCount: PropTypes.number,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default SolyticsFilterButton;
